// import React, { useState } from "react";
import ApiData from "../../api/ApiData";
import stateFilter from "../../state/state.filter";
import ItemSoftCompany from "./ItemSoftCompany";
import { observer } from "mobx-react-lite";

export const ListSoftCompany = observer(
  ({
    actionClientLicSet,
    actionClientLicRemove,
    actionClientLicRenewal,
    v4Layout,
    rowClass,
  }) => {

    return (
      <div className={v4Layout ? "list_text cc-v4-soft-body" : "list_text"}>
        {ApiData.company.clients_soft
          .filter((i) => {
            // Проверка на сервер (если фильтр включен)
            const matchesServer = stateFilter.filter_active_server
              ? i.software_client_rel.type === "SRV"
              : true;

            // Проверка на активность клиента (если фильтр включен)
            const matchesActive = stateFilter.filter_active_client
              ? i.activ_data !== "" && i.activ_data !== null
              : true;

            // Элемент остается, только если прошел ОБЕ проверки
            return matchesServer && matchesActive;
          })
          .map((itemsoft) => (
            <ItemSoftCompany
              v4Layout={v4Layout}
              rowClass={rowClass}
              actionClientLicRemove={actionClientLicRemove}
              actionClientLicSet={actionClientLicSet}
              actionClientLicRenewal={actionClientLicRenewal}
              key={itemsoft.client_id}
              itemsoft={itemsoft}
              software_rel={itemsoft.software_client_rel}
            />
          ))}
      </div>
    );
  },
);
